export enum EmployeeRole {
    Admin = "1",
    Teacher = "5",
}